import * as React from 'react';
import { cn } from '@/lib/utils';

export interface VerticalSeparatorProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** セパレーターの高さ（px） */
  height?: number;
  /** セパレーターの色 */
  color?: string;
}

/**
 * VerticalSeparator - 縦線セパレーター
 *
 * 番号とラベルの間に配置する縦線です。
 * 主にリスト項目の装飾として使用します。
 *
 * @example
 * ```tsx
 * // デフォルト
 * <VerticalSeparator />
 *
 * // 高さ指定
 * <VerticalSeparator height={20} />
 *
 * // 色指定
 * <VerticalSeparator color="#A0A09D" />
 *
 * // カスタムクラス
 * <VerticalSeparator className="mx-2" />
 * ```
 */
export const VerticalSeparator = React.forwardRef<
  HTMLDivElement,
  VerticalSeparatorProps
>(({ className, height = 12, color = '#A0A09D', style, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('inline-block', className)}
      style={{
        width: '1px',
        height: `${height}px`,
        ...style,
      }}
      {...props}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <line x1="0.5" y1="0" x2="0.5" y2="12" stroke={color} />
      </svg>
    </div>
  );
});

VerticalSeparator.displayName = 'VerticalSeparator';
